module.exports = __webpack_public_path__ + "img/question-mark.1c65d9fd.svg";